import { useRef, useState } from 'react';
import type { DashboardSectionIndex, Me } from './api';
import { CataloguePanel, SalesPanel } from './Commerce';
import { DashboardPanels } from './Dashboard';
import { BankaHesaplari, SalesWorkflowPanel } from './Workflow';
import { SATIS_UI as T, type SalesView } from './metin/satis-ui';
import './sales.css';

export function SalesWorkspace({ me, sections }: { me: Me; sections?: DashboardSectionIndex | null }) {
  /**
   * Panel `new` ile doguyor ve `new` ilk sekme. Urun Sahibi, 21.09.2026 CRM incelemesi:
   * "satis paneli yeni satis sayfasiyla acilsin, ilk tab yeni satis olsun." Onceki halde
   * `new` sekme listesinde hic yoktu; oraya yalnizca sag ustteki dugmeden girilebiliyordu,
   * yani satisin kendisi panelin gorunmeyen bir kosesindeydi.
   */
  const [view, setView] = useState<SalesView>(() => me.permissions.includes('sales:write') ? 'new' : me.permissions.includes('quote:margin_approve') ? 'approvals' : me.permissions.includes('workflow:read') ? 'requests' : 'queues');
  const bankDialog = useRef<HTMLDialogElement>(null);
  const tabs: SalesView[] = [
    ...(me.permissions.includes('sales:write') ? ['new', 'overview'] as const : []),
    ...(me.permissions.includes('workflow:read') ? ['requests'] as const : []),
    ...(me.permissions.includes('sales:write') ? ['quotes', 'orders'] as const : []),
    ...(me.permissions.includes('quote:margin_approve') ? ['approvals'] as const : []),
    ...(sections ? ['queues'] as const : []),
    // Web sitesi bölümünden taşındı (Ürün Sahibi, 07.10.2026): v3 satış raporu ve ürün kataloğu.
    ...(me.permissions.includes('commerce:sales_read') ? ['webReport'] as const : []),
    ...(me.permissions.includes('commerce:catalogue_read') ? ['webCatalogue'] as const : []),
  ];
  return <div className="sales-workspace">
    <div className="sales-heading"><div><span className="eyebrow">{T.eyebrow}</span><h2>{view === 'overview' ? T.heading : T.tabs[view]}</h2></div>
      <div className="sales-heading-actions">{me.permissions.includes('sales:write') ? <button className="birincil" data-testid="sales-new" onClick={() => setView('new')}><span aria-hidden="true">＋</span>{T.newSale}</button> : null}
      <button type="button" data-testid="sales-bank-open" aria-haspopup="dialog" onClick={() => bankDialog.current?.showModal()}>{T.bankInformation}</button></div>
    </div>
    <dialog ref={bankDialog} className="sales-catalogue-dialog sales-bank-dialog" aria-labelledby="sales-bank-dialog-title" data-testid="sales-bank-dialog">
      <header><h3 id="sales-bank-dialog-title">{T.bankInformation}</h3><button type="button" autoFocus data-testid="sales-bank-close" onClick={() => bankDialog.current?.close()}>{T.close}</button></header>
      <BankaHesaplari />
    </dialog>
    <nav className="sales-tabs" aria-label={T.title}>{tabs.map((tab) => <button key={tab} data-testid={`sales-tab-${tab}`} aria-current={view === tab ? 'page' : undefined} onClick={() => setView(tab)}>{T.tabs[tab]}</button>)}</nav>
    <SalesWorkflowPanel me={me} view={view} onView={setView} />
    {view === 'webReport' ? <div className="workflow-stack" data-testid="sales-web-report"><SalesPanel /></div> : null}
    {view === 'webCatalogue' ? <div className="workflow-stack" data-testid="sales-web-catalogue"><CataloguePanel /></div> : null}
    {view === 'queues' ? <div className="workflow-stack"><DashboardPanels sections={sections ?? null} only="SALES" /></div> : null}
  </div>;
}
